import getErrorMessageFromStatus from 'utils/getErrorMessageFromStatus';
import federalBasicPermitsApi from './federalBasicPermits.api';
import { raiseError } from '../messages/messages.actions';
import fbpnErrorMessages from './federalBasicPermits.errors';

export const LOAD_SUGGESTIONS_START = Symbol('LOAD_SUGGESTIONS_START');
export const LOAD_SUGGESTIONS_SUCCESS = Symbol('LOAD_SUGGESTIONS_SUCCESS');
export const LOAD_SUGGESTIONS_ERROR = Symbol('LOAD_SUGGESTIONS_ERROR');

export const CLEAR_SUGGESTIONS = Symbol('CLEAR_SUGGESTIONS');


const loadSuggestionsStart = key => ({ type: LOAD_SUGGESTIONS_START, key });
const loadSuggestionsSuccess = (key, response) => ({ type: LOAD_SUGGESTIONS_SUCCESS, response, key });
const loadSuggestionsError = key => ({ type: LOAD_SUGGESTIONS_ERROR, key });

const clearSuggestionsStart = key => ({ type: CLEAR_SUGGESTIONS, key });

export function loadSuggestions(search, key) {
  return async function loadSuggestionsThunk(dispatch) {
    dispatch(loadSuggestionsStart(key));
    federalBasicPermitsApi.loadSuggestions(search)
      .then(response => dispatch(loadSuggestionsSuccess(key, response)))
      .catch((error) => {
        const errorObject = new Error(getErrorMessageFromStatus(error.response.status, fbpnErrorMessages));
        dispatch(raiseError(errorObject));
        dispatch(loadSuggestionsError(key));
      });
  };
}

export function clearSuggestions(key) {
  return async function clearSuggestionsThunk(dispatch) {
    dispatch(clearSuggestionsStart(key));
  };
}
